import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@/design-system/lib/cn';

/** Card branco: borda `line-card`, raio 14px, sombra quase imperceptível. */
export function Card({ className, ...props }: ComponentProps<'section'>) {
  return (
    <section
      className={cn('rounded-card border border-line-card bg-white shadow-card', className)}
      {...props}
    />
  );
}

/** Cabeçalho de card: título (h2, 17px) e uma ação ou contador à direita. */
export function CardHeader({
  title,
  aside,
  description,
  className,
  level = 'section',
}: {
  title: ReactNode;
  aside?: ReactNode;
  description?: ReactNode;
  className?: string;
  /** `section` = 17px (dashboard); `block` = 15px (formulários e resultados). */
  level?: 'section' | 'block';
}) {
  return (
    <div className={cn('flex items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <h2
          className={cn(
            'm-0 font-bold tracking-[-0.01em] text-ink',
            level === 'section' ? 'text-title-sm' : 'text-body-lg'
          )}
        >
          {title}
        </h2>
        {description ? <p className="m-0 text-small text-ink-subtle">{description}</p> : null}
      </div>
      {aside}
    </div>
  );
}
